import { render, staticRenderFns } from "./dashBoard.vue?vue&type=template&id=08186946&scoped=true&"
import script from "./dashBoard.vue?vue&type=script&lang=js&"
export * from "./dashBoard.vue?vue&type=script&lang=js&"
import style0 from "./dashBoard.vue?vue&type=style&index=0&lang=css&"
import style1 from "./dashBoard.vue?vue&type=style&index=1&id=08186946&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08186946",
  null
  
)

export default component.exports